import React, { useContext } from 'react';

import { FiVolume2, FiVolume1, FiVolume } from 'react-icons/fi';
import { PlayerContext } from '../../../contexts/player.context';

import Slider from 'react-rangeslider';

import { VolumeContainer, SliderContainer } from './VolumeSlider.styles';

const VolumeSlider = () => {
  const { setVolume, volume } = useContext(PlayerContext);
  const handleChange = value => {
    setVolume(value);
  };
  return (
    <VolumeContainer>
      <div>
        <SliderContainer>
          <Slider
            min={0}
            max={1}
            step={0.01}
            value={volume}
            orientation="vertical"
            onChange={handleChange}
            tooltip={false}
          />
        </SliderContainer>
      </div>
      {volume === 0 ? (
        <FiVolume size="2.4rem" />
      ) : volume < 0.7 ? (
        <FiVolume1 size="2.4rem" />
      ) : (
        <FiVolume2 size="2.4rem" />
      )}
    </VolumeContainer>
  );
};

export default VolumeSlider;
